import React, { useState } from 'react';
import { X, Search, Image as ImageIcon } from 'lucide-react';

export default function MediaCenterModal({ isOpen, onClose, onConfirm, images = [] }) {
    const [selectedItems, setSelectedItems] = useState([]);

  
    const toggleSelection = (item) => {
      setSelectedItems(prev => 
        prev.some(p => p.id === item.id) 
        ? prev.filter(p => p.id !== item.id)
        : [...prev, item]
      );
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl h-[85vh] flex flex-col">
                {/* Header */}
                 <div className='p-4 border-b'>
                     <h3 className='font-semibold text-lg'>Media Center - Images</h3>
                 </div>
                 {/* Body */}
                 <div className='flex-grow p-4 overflow-y-auto'>
                     <div className='grid grid-cols-6 gap-4'>
                         {images.length > 0 ? (
                           images.map(item => {
                             return (
                               <div key={item.id} onClick={() => toggleSelection(item)} className={`border-2 rounded-md aspect-square relative cursor-pointer ${selectedItems.some(p => p.id === item.id) ? 'border-orange-500' : 'border-transparent'}`}>
                                  <img 
                                    src={item.url} 
                                    className='w-full h-full object-cover rounded-sm' 
                                    alt={item.title || item.name || item.id}
                                  />
                                  <div className='absolute top-1 right-1 bg-white h-4 w-4 rounded-sm border border-slate-400 flex items-center justify-center'>
                                       {selectedItems.some(p => p.id === item.id) && <div className='h-2.5 w-2.5 bg-orange-500 rounded-sm' />}
                                  </div>
                               </div>
                             )
                           })
                         ) : (
                           <div className="col-span-6 text-center py-8 text-slate-500">
                             No images available
                           </div>
                         )}
                     </div>
                 </div>
                 {/* Footer */}
                <div className="p-4 border-t flex justify-between items-center">
                    <div>Selected: {selectedItems.length}</div>
                    <div className="flex gap-2">
                        <button onClick={onClose} className="px-6 py-2 border rounded-md text-sm">Cancel</button>
                        <button onClick={() => onConfirm(selectedItems)} className="px-6 py-2 bg-orange-500 text-white rounded-md text-sm">Insert Selected</button>
                    </div>
                </div>
            </div>
        </div>
    )
}